import { IFeatures } from '../models/featureFlags';
import { LEFT_NAV_PERSONAS } from '../models/persona';

// note all service ids are lowercase
export const SERVICE_IDS = {
    home: 'home',
    automationhub: 'automationhub',
    automationstore: 'automationstore',
    actions: 'actions',
    apps: 'apps',
    chatbots: 'chatbots',
    entities: 'entities',
    orchestrator: 'orchestrator',
    processes: 'processes',
    insights: 'insights',
    marketplace: 'marketplace',
    testmanager: 'testmanager',
    integrations: 'connections', // Note: this is by design; integrations is using connections as their URL
    dataservice: 'dataservice',
    taskmining: 'taskmining',
    processmining: 'processmining',
    studio: 'studio',
    du: 'du',
    reinfer: 'reinfer',
    roboticsops: 'roboticsops',
    admin: 'admin',
    aifabric: 'aifabric',
    help: 'help',
};

export const defaultServiceOrder = [
    SERVICE_IDS.home,
    SERVICE_IDS.orchestrator,
    SERVICE_IDS.studio,
    SERVICE_IDS.actions,
    SERVICE_IDS.automationhub,
    SERVICE_IDS.apps,
    SERVICE_IDS.chatbots,
    SERVICE_IDS.processes,
    SERVICE_IDS.insights,
    SERVICE_IDS.marketplace,
    SERVICE_IDS.testmanager,
    SERVICE_IDS.integrations,
    SERVICE_IDS.dataservice,
    SERVICE_IDS.taskmining,
    SERVICE_IDS.processmining,
    SERVICE_IDS.aifabric,
    SERVICE_IDS.du,
    SERVICE_IDS.reinfer,
    SERVICE_IDS.roboticsops,
    SERVICE_IDS.admin,
    SERVICE_IDS.automationstore,
    SERVICE_IDS.help,
];

export enum SERVICE_ORDER_FLAGS {
    AdminServiceOrder = 'apollo-AdminServiceOrder',
    RPADeveloperServiceOrder = 'apollo-RPADeveloperServiceOrder',
    CitizenDevServiceOrder = 'apollo-CitizenDevServiceOrder',
    BusinessAnalystServiceOrder = 'apollo-BusinessAnalystServiceOrder',
    BusinessUserServiceOrder = 'apollo-BusinessUserServiceOrder',
    AutomationExpressUserServiceOrder = 'apollo-AutomationExpressUserServiceOrder',
    AutomationExpressAdminServiceOrder = 'apollo-AutomationExpressAdminServiceOrder',
    TesterServiceOrder = 'apollo-TesterServiceOrder',
}

export const defaultServiceOrdersForFlag = {
    [SERVICE_ORDER_FLAGS.AdminServiceOrder]: {
        core: [
            SERVICE_IDS.home,
            SERVICE_IDS.orchestrator,
            SERVICE_IDS.insights,
            SERVICE_IDS.studio,
            SERVICE_IDS.apps,
            SERVICE_IDS.automationhub,
            SERVICE_IDS.integrations,
            SERVICE_IDS.admin,
        ],
        more: [
            SERVICE_IDS.actions,
            SERVICE_IDS.aifabric,
            SERVICE_IDS.roboticsops,
            SERVICE_IDS.automationstore,
            SERVICE_IDS.reinfer,
            SERVICE_IDS.dataservice,
            SERVICE_IDS.du,
            SERVICE_IDS.marketplace,
            SERVICE_IDS.processmining,
            SERVICE_IDS.processes,
            SERVICE_IDS.taskmining,
            SERVICE_IDS.testmanager,
        ],
    },
    [SERVICE_ORDER_FLAGS.RPADeveloperServiceOrder]: {
        core: [
            SERVICE_IDS.home,
            SERVICE_IDS.orchestrator,
            SERVICE_IDS.insights,
            SERVICE_IDS.studio,
            SERVICE_IDS.apps,
            SERVICE_IDS.du,
            SERVICE_IDS.actions,
            SERVICE_IDS.processes,
        ],
        more: [
            SERVICE_IDS.aifabric,
            SERVICE_IDS.automationhub,
            SERVICE_IDS.roboticsops,
            SERVICE_IDS.automationstore,
            SERVICE_IDS.reinfer,
            SERVICE_IDS.dataservice,
            SERVICE_IDS.integrations,
            SERVICE_IDS.marketplace,
            SERVICE_IDS.processmining,
            SERVICE_IDS.taskmining,
            SERVICE_IDS.testmanager,
        ],
    },
    [SERVICE_ORDER_FLAGS.CitizenDevServiceOrder]: {
        core: [
            SERVICE_IDS.home,
            SERVICE_IDS.studio,
            SERVICE_IDS.apps,
            SERVICE_IDS.du,
            SERVICE_IDS.actions,
            SERVICE_IDS.automationhub,
            SERVICE_IDS.processes,
            SERVICE_IDS.taskmining,
        ],
        more: [
            SERVICE_IDS.aifabric,
            SERVICE_IDS.roboticsops,
            SERVICE_IDS.automationstore,
            SERVICE_IDS.reinfer,
            SERVICE_IDS.dataservice,
            SERVICE_IDS.insights,
            SERVICE_IDS.integrations,
            SERVICE_IDS.marketplace,
            SERVICE_IDS.orchestrator,
            SERVICE_IDS.processmining,
        ],
    },
    [SERVICE_ORDER_FLAGS.BusinessAnalystServiceOrder]: {
        core: [
            SERVICE_IDS.home,
            SERVICE_IDS.actions,
            SERVICE_IDS.insights,
            SERVICE_IDS.processmining,
            SERVICE_IDS.taskmining,
            SERVICE_IDS.automationhub,
            SERVICE_IDS.marketplace,
        ],
        more: [
            SERVICE_IDS.apps,
            SERVICE_IDS.aifabric,
            SERVICE_IDS.roboticsops,
            SERVICE_IDS.automationstore,
            SERVICE_IDS.reinfer,
            SERVICE_IDS.dataservice,
            SERVICE_IDS.orchestrator,
            SERVICE_IDS.processes,
            SERVICE_IDS.testmanager,
        ],
    },
    [SERVICE_ORDER_FLAGS.BusinessUserServiceOrder]: {
        core: [
            SERVICE_IDS.home,
            SERVICE_IDS.actions,
            SERVICE_IDS.apps,
            SERVICE_IDS.automationhub,
            SERVICE_IDS.automationstore,
            SERVICE_IDS.marketplace,
            SERVICE_IDS.processes,
            SERVICE_IDS.taskmining,
        ],
        more: [
            SERVICE_IDS.aifabric,
            SERVICE_IDS.roboticsops,
            SERVICE_IDS.reinfer,
            SERVICE_IDS.integrations,
            SERVICE_IDS.dataservice,
            SERVICE_IDS.du,
            SERVICE_IDS.insights,
            SERVICE_IDS.orchestrator,
            SERVICE_IDS.processmining,
            SERVICE_IDS.testmanager,
        ],
    },
    [SERVICE_ORDER_FLAGS.AutomationExpressUserServiceOrder]: {
        core: [
            SERVICE_IDS.home,
            SERVICE_IDS.studio,
            SERVICE_IDS.integrations,
            SERVICE_IDS.insights,
            SERVICE_IDS.automationhub,
            SERVICE_IDS.marketplace,
            SERVICE_IDS.taskmining,
        ],
        more: [
            SERVICE_IDS.roboticsops,
            SERVICE_IDS.reinfer,
            SERVICE_IDS.orchestrator,
        ],
    },
    [SERVICE_ORDER_FLAGS.AutomationExpressAdminServiceOrder]: {
        core: [
            SERVICE_IDS.home,
            SERVICE_IDS.studio,
            SERVICE_IDS.integrations,
            SERVICE_IDS.insights,
            SERVICE_IDS.automationhub,
            SERVICE_IDS.marketplace,
            SERVICE_IDS.taskmining,
            SERVICE_IDS.admin,
        ],
        more: [
            SERVICE_IDS.roboticsops,
            SERVICE_IDS.reinfer,
            SERVICE_IDS.orchestrator,
        ],
    },
    [SERVICE_ORDER_FLAGS.TesterServiceOrder]: {
        core: [
            SERVICE_IDS.home,
            SERVICE_IDS.testmanager,
            SERVICE_IDS.taskmining,
            SERVICE_IDS.orchestrator,
            SERVICE_IDS.reinfer,
            SERVICE_IDS.roboticsops,
        ],
        more: [],
    },
};

export const defaultServiceOrderByPersona = (
    getFeatureFlags: <T extends boolean | Object = boolean>(keys: string[]) => T[],
    Features: IFeatures,
) => {
    const [
        AdminServiceOrder,
        RPADeveloperServiceOrder,
        CitizenDevServiceOrder,
        BusinessAnalystServiceOrder,
        BusinessUserServiceOrder,
        AutomationExpressUserServiceOrder,
        AutomationExpressAdminServiceOrder,
        TesterServiceOrder,
    ] = getFeatureFlags<Object>([
        Features.AdminServiceOrder.name,
        Features.RPADeveloperServiceOrder.name,
        Features.CitizenDevServiceOrder.name,
        Features.BusinessAnalystServiceOrder.name,
        Features.BusinessUserServiceOrder.name,
        Features.AutomationExpressUserServiceOrder.name,
        Features.AutomationExpressAdminServiceOrder.name,
        Features.TesterServiceOrder.name,
    ]);

    return {
        [LEFT_NAV_PERSONAS.ADMIN]: AdminServiceOrder,
        [LEFT_NAV_PERSONAS.RPA_DEVELOPER]: RPADeveloperServiceOrder,
        [LEFT_NAV_PERSONAS.CITIZEN_DEV]: CitizenDevServiceOrder,
        [LEFT_NAV_PERSONAS.BUSINESS_ANALYST]: BusinessAnalystServiceOrder,
        [LEFT_NAV_PERSONAS.BUSINESS_USER]: BusinessUserServiceOrder,
        [LEFT_NAV_PERSONAS.AUTOMATION_EXPRESS_USER]: AutomationExpressUserServiceOrder,
        [LEFT_NAV_PERSONAS.AUTOMATION_EXPRESS_ADMIN]: AutomationExpressAdminServiceOrder,
        [LEFT_NAV_PERSONAS.TESTER]: TesterServiceOrder,
        [LEFT_NAV_PERSONAS.UNKNOWN]: {
            core: [ ...defaultServiceOrder ],
            more: [],
        },
        [LEFT_NAV_PERSONAS.INITIAL]: {
            core: [ ...defaultServiceOrder ],
            more: [],
        },
    };
};
